import viJson from "./vi.json";

export const vi = viJson;

export type Dictionary = typeof viJson;
